/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import api from '@redux/apis/baseApi'
import { API_RESOURCE } from '@constants/api'
import { formatDateISOString } from '@utils/time'

const CACHE_NAMES = ['Events'] as const

const eventApi = api.injectEndpoints({
  endpoints: build => ({
    getEvents: build.query<
      Response.Event.EventAPI,
      {
        from: string
        to: string
        cursor?: string
        nextEnableEventTableType?: Redux.EventType
      }
    >({
      query: ({ from, to, cursor, nextEnableEventTableType }) => ({
        url: `${API_RESOURCE.EVENT}?from=${formatDateISOString(
          from
        )}&to=${formatDateISOString(to)}${
          nextEnableEventTableType === 'error' ? '&hasError=true' : ''
        }${cursor ? `&cursor=${cursor}` : ''}`,
      }),
    }),
  }),
})

eventApi.enhanceEndpoints({
  addTagTypes: CACHE_NAMES,
  endpoints: {
    getEvents: {
      providesTags: CACHE_NAMES,
    },
  },
})

export default eventApi
